module.exports = __webpack_public_path__ + "img/business.7a40a693.webp";